module.exports = __webpack_public_path__ + "media/warranty-claim/truck-ef03be93.svg";